import { useCallback, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../hooks"
import { getSessionToken } from "../../../network"
import { setUsdcBalance } from "../../../stores/NetworkStore"

interface WalletLimits {
  maxDepositPerTx: number
  maxDailyDeposit: number
  maxWithdrawalPerTx: number
  maxDailyWithdrawal: number
}

export function useWalletBalance() {
  const dispatch = useAppDispatch()
  const profile = useAppSelector((state) => state.network.profile)
  const [balance, setBalance] = useState<number>(profile?.usdcBalance ?? 0)
  const [limits, setLimits] = useState<WalletLimits | null>(null)
  const [loading, setLoading] = useState(false)

  const fetchBalance = useCallback(async () => {
    setLoading(true)
    try {
      const token = getSessionToken()
      const res = await fetch("/wallet/balance", {
        headers: { Authorization: `Bearer ${token}` }
      })
      if (res.ok) {
        const data = await res.json()
        setBalance(data.balance)
        dispatch(setUsdcBalance(data.balance))
        if (data.limits) {
          setLimits(data.limits)
        }
      }
    } catch (e) {
      console.error("Failed to fetch wallet balance:", e)
    } finally {
      setLoading(false)
    }
  }, [dispatch])

  return { balance, limits, loading, fetchBalance }
}
